import { Settings } from "../utils/settings";
import { LiturgyItem } from "./types";

export const getSuffrages = (settings: Settings): LiturgyItem[] => {
    return [
        {
            type: "chant",
            boldMode: "alternate",
            tone: "2.1",
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "show",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "mer",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "cy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "up",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "on",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "grant",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },

                            {
                                syllables: [
                                    {
                                        text: "sal",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "va",
                                        notes: ["5"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "tion.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "save",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text:
                                            settings.monarch === "yes"
                                                ? "King."
                                                : "State.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "mer",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ci",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ful",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ly",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hear",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "when",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "call",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "up",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "on",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thee.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "En",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "due",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Mi",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ni",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "sters",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "right",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "eous",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ness.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "make",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "cho",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "sen",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "peo",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ple",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "joy",
                                        notes: ["5"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ful.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "save",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "peo",
                                        notes: ["5"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ple.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "bless",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "he",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ance.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Give",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "peace",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "time,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Be",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "cause",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "there",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "is",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "none",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "oth",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "er",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "that",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "fight",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "eth",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "but",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "on",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ly",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "God.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "God,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "make",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "clean",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hearts",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "in",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "take",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "not",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Ho",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ly",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Spi",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "from",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    ];
};
